<template>
  <div class="register">
    <v-stepper class="stepper" v-model="selectedStep">
      <v-stepper-header>
        <v-stepper-step color="green" step="1"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="2"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="3"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="4"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="5"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="6" complete></v-stepper-step>
      </v-stepper-header>

      <v-stepper-items class="items">
        <v-stepper-content class="content" step="1">
          <h1>Gib jetzt allgemeine Vereinsdaten ein.</h1>

          <hr class="green-line" />

          <label>Vollständiger Vereinsname <span>*</span></label>
          <v-text-field
            color="green"
            v-model="common_infos.team_name"
            placeholder="FC Musterverein e.V."
            solo
          ></v-text-field>

          <label>
            Ansässig in Land
            <span>*</span>
          </label>
          <v-autocomplete
            color="green"
            :items="$store.state.nationalities"
            item-text="item_text"
            item-value="id"
            v-model="user_data.nationality"
            solo
            attach
          ></v-autocomplete>

          <label>
            Region/Verband
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="$store.state.verband"
            v-model="user_data.verband"
            solo
          ></v-select>

          <label v-if="user_data.verband">
            Aktuelle Liga
            <span>*</span>
          </label>
          <v-select
            v-if="user_data.verband"
            color="green"
            :items="$store.state.filter_leagues[user_data.verband]"
            item-text="league"
            item-value="category"
            return-object
            v-model="user_data.category"
            solo
          ></v-select>

          <v-btn color="white green--text" @click="backToRegister" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :disabled="
              user_data.verband == '' ||
              user_data.nationality == '' ||
              !user_data.category ||
              !common_infos.team_name
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="2">
          <h1>Gib hier die Namen der offiziellen Vereinsverantwortlichen ein.</h1>

          <hr class="green-line" />

          <label>
            Sportlicher Leiter
            <span>*</span>
          </label>
          <v-text-field
            placeholder="Vor- und Nachname"
            color="green"
            v-model="settings.sportlicher_leiter"
            solo
          />
          <label>
            Cheftrainer/-in
            <span>*</span>
          </label>
          <v-text-field
            placeholder="Vor- und Nachname"
            color="green"
            v-model="settings.cheftrainer"
            solo
          />

          <h2 class="middle_header">
            Wünscht du ein persönliches Gespräch mit unserer Geschäftsführung zu den
            exklusiven Vorteilen des C4T-Saisontickets?
          </h2>

          <div class="row">
            <div style="display: inline-block">
              <v-radio-group
                v-model="settings.contact_needed"
                color="green"
                :column="false"
              >
                <v-radio color="green" label="Ja" value="ja"></v-radio>
                <v-radio color="green" label="Nein" value="nein"></v-radio>
              </v-radio-group>
            </div>
          </div>

          <div v-if="settings.contact_needed === 'ja'">
            <label>
              Ansprechpartner
              <span>*/**</span>
            </label>
            <v-text-field
              placeholder="Vor- und Nachname"
              color="green"
              v-model="settings.contact_needed_data.name"
              solo
            />

            <label>
              Telefonnummer
              <span>*/**</span>
            </label>
            <v-text-field
              placeholder="+491234567890"
              color="green"
              v-model="settings.contact_needed_data.phone"
              solo
            />

            <p>** Daten werden nicht im Vereinsprofil veröffentlicht.</p>
          </div>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :disabled="
              !settings.cheftrainer ||
              !settings.sportlicher_leiter ||
              !isContactNeededFilled
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="3">
          <h1>Ein Vereinslogo ist immer vorteilhaft.</h1>
          <h3>Das kannst du auch später erledigen.</h3>

          <hr class="green-line" />

          <div v-if="common_infos.big_thumbnail" class="upload-change-wrapper">
            <img
              class="register-avatar register-avatar__big"
              :src="common_infos.big_thumbnail"
              alt=""
            />
            <label class="upload-label" for="upload-photo">Bild ändern</label>
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>
          <div v-else class="upload-wrapper">
            <label class="upload-label" for="upload-photo">Bild auswählen</label>
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>

          <br />
          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" @click="next">Weiter</v-btn>
        </v-stepper-content>

        <v-stepper-content class="content" step="4">
          <h1>
            Hier kannst du vorauswählen, welche Attribute Spieler/Trainer haben müssen,
            um für euch interessant zu sein.
          </h1>
          <h3>Dies ist später natürlich anpassbar.</h3>

          <hr class="green-line" />

          <label>
            Aktueller Bedarf
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="need"
            v-model="settings.will_be_found_by"
            solo
          ></v-select>

          <div
            class="range-slide"
            v-if="
              settings.will_be_found_by === 'Spieler' ||
              settings.will_be_found_by === 'Spieler & Trainer'
            "
          >
            <h1>Spielerattribute</h1>

            <label
              >Alter (von {{ settings.playerAgeRange[0] }} bis
              {{ settings.playerAgeRange[1] }})</label
            >
            <v-range-slider
              solo
              class="age-slider"
              color="green"
              v-model="settings.playerAgeRange"
              :min="14"
              :max="40"
            ></v-range-slider>
            <label>Geschlecht</label>
            <v-select
              color="green"
              :items="$store.state.sex"
              v-model="settings.playerprofile_sex"
              multiple
              solo
            ></v-select>

            <label>Position</label>
            <v-select
              color="green"
              :items="$store.state.positions"
              v-model="settings.playerprofile_position"
              solo
              multiple
            ></v-select>
          </div>

          <div
            v-if="
              settings.will_be_found_by === 'Trainer' ||
              settings.will_be_found_by === 'Spieler & Trainer'
            "
          >
            <h1>Trainerattribute</h1>
            <label
              >Alter (von {{ settings.trainerAgeRange[0] }} bis
              {{ settings.trainerAgeRange[1] }})</label
            >
            <v-range-slider
              solo
              class="age-slider"
              color="green"
              v-model="settings.trainerAgeRange"
              :min="14"
              :max="80"
            ></v-range-slider>
            <label>Geschlecht</label>
            <v-select
              color="green"
              :items="$store.state.sex"
              v-model="settings.trainerprofile_sex"
              solo
              multiple
            ></v-select>

            <label>Trainertyp</label>
            <v-select
              color="green"
              multiple
              :items="$store.state.trainer_types"
              v-model="settings.trainerprofile_type"
              solo
            ></v-select>
          </div>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            @click="next"
            :disabled="!settings.will_be_found_by"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="5">
          <h1>
            Zuletzt brauchen wir noch eine gültige E-Mail-Adresse und ein sicheres
            Passwort.
          </h1>

          <hr class="green-line" />

          <label>E-Mail</label>
          <v-text-field
            :rules="[rules.required]"
            color="green"
            v-model="email"
            solo
          ></v-text-field>

          <label>Passwort</label>
          <v-text-field
            v-model="password"
            :append-icon="showPW ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="showPW ? 'text' : 'password'"
            name="input-10-1"
            :loading="loading"
            solo
            color="green"
            hint="min. 8 Zeichen"
            counter
            @click:append="showPW = !showPW"
          ></v-text-field>

          <v-checkbox class="check_nospace" color="green" v-model="checkbox_anb">
            <template v-slot:label>
              <div class="check_label">
                Ich erkläre mich mit den
                <a target="_blank" href="https://www.chance4talents.de/anbs.html"
                  >ANB</a
                >
                der CHANCE4TALENTS GmbH einverstanden.
              </div>
            </template>
          </v-checkbox>

          <v-checkbox
            class="check_nospace"
            color="green"
            v-model="checkbox_datenschutz"
          >
            <template v-slot:label>
              <div class="check_label">
                Ich erkläre mich mit der
                <a target="_blank" href="http://www.chance4talents.de/datenschutz.html"
                  >Datenschutzerklärung</a
                >
                der CHANCE4TALENTS GmbH einverstanden.
              </div>
            </template>
          </v-checkbox>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :loading="loading"
            :disabled="
              password.length < 8 || !email || !checkbox_anb || !checkbox_datenschutz
            "
            @click="registerTeam()"
            >Erledigt</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="6">
          <h1 style="color: green; margin: 20px; 0">
            Glückwunsch, deine Registrierung war erfolgreich.
          </h1>
          <h3 style="color: black; margin-bottom: 10px">
            Jetzt fehlt nur noch die offizielle Verifizierung deines Accounts, um den
            begehrten blauen C4T-Ring zu erhalten!
          </h3>
          <h3>
            Geh dazu bitte in dein E-Mail Postfach und bestätige per blauen Button deine
            angegebene E-Mail Adresse.
          </h3>

          <hr class="green-line" />

          <p>
            Hinweis: Solltest du keine E-Mail erhalten haben, dann schau bitte auch in
            deinem SPAM-Ordner nach.
          </p>
          <h3 class="middle_header">
            Vielen Dank für deine Registrierung,<br />dein C4T-Team
          </h3>

          <v-btn color="green white--text" @click="toLogin()">Zum Login</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <CroppieDialog
      ref="croppieDialog"
      :image="imageSrc"
      :show.sync="showCroppie"
      @upload="cropRegistrationAvatarTeam"
    />
  </div>
</template>

<script>
import axios from 'axios';
import firebase from 'firebase';
import { db } from '@/db';
import croppieMixin from '../../mixins/croppie';
import pushMixin from '../../mixins/push-notifications';
import registerMixin from '../../mixins/register';
import CroppieDialog from '../../components/dialogs/CroppieDialog';
import { cloudFunctions } from '../../config';

export default {
  name: 'register-team',

  components: {
    CroppieDialog,
  },

  mixins: [croppieMixin, pushMixin, registerMixin],

  data: () => ({
    checkbox_anb: false,
    checkbox_datenschutz: false,
    selectedStep: 1,
    team_name: '',
    email: '',
    password: '',
    loading: false,
    discount: false,
    showPW: false,
    need: ['Spieler', 'Trainer', 'Spieler & Trainer', 'Kein Bedarf'],
    common_infos: {
      name: '',
      date: '',
      profile_pic: '',
      history: [],
    },
    settings: {
      contact_needed: 'ja',
      contact_needed_data: {},
      playerAgeRange: [14, 22],
      trainerAgeRange: [30, 52],
      already_matched: [],
      player_country: 'Deutschland',
      trainer_country: 'Deutschland',
      userType: 'teams',
      galleryImages: ['', '', '', ''],
      newslinks: {
        0: {
          title: '',
          link: '',
        },
        1: {
          title: '',
          link: '',
        },
      },
      videolinks: {
        0: {
          title: '',
          link: '',
        },
        1: {
          title: '',
          link: '',
        },
      },
    },
    rules: {
      required: (value) => !!value || '*Pflichtfeld.',
      min: (v) => v.length >= 8 || '*min. 8 Zeichen',
    },
  }),
  computed: {
    user_data() {
      return this.$store.state.user_data;
    },

    isContactNeededFilled() {
      return this.settings.contact_needed === 'nein'
        ? true
        : this.settings.contact_needed_data.name &&
            this.settings.contact_needed_data.phone;
    },
  },
  mounted() {
    window.addEventListener('beforeunload', (e) => {
      // Cancel the event
      e.preventDefault();
      // Chrome requires returnValue to be set
      e.returnValue = '';
    });
  },
  beforeMount() {
    this.$gtm.push({
      event: 'registration_start',
      registration_progress: 'start',
      registration_category: 'registerTeam',
    });
    if (localStorage.discount) {
      this.discount = true;
    }
  },
  methods: {
    back() {
      this.selectedStep--;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'registerTeam',
      });
      window.scrollTo(0, 0);
    },

    next() {
      this.selectedStep++;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'registerTeam',
      });
      window.scrollTo(0, 0);
    },

    loginUser(email, password) {
      this.$store.state.credentials = {
        password,
        email,
      };
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((userRecord) => {
          const { user } = userRecord;

          const user_id = user.uid;
          this.$store.state.user_id = user_id;
          const userType = user.displayName;
          this.$store.state.userType = userType;
          return { user_id, userType };
        })
        .then((resp) => db.collection(resp.userType).doc(resp.user_id).get())
        .then((snapshot) => {
          const document = snapshot.data();
          this.$store.state.user_data = document;

          return document.userType;
        })
        .then(async (userType) => {
          this.$store.dispatch('bindUserData', {
            userType,
            id: this.$store.state.user_data.id,
          });
          await this.setDefaultMessagingSettings(this.user_data);
        })
        .catch((error) => {
          if (error.code === 'auth/email-already-exists') {
            this.$store.state.snackText = 'Email existiert schon';
            this.$store.state.snackbar = true;
          }
          if (
            error.code === 'auth/wrong-password' ||
            error.code === 'auth/user-not-found'
          ) {
            this.$store.state.snackText = 'Falsche Logindaten';
            this.$store.state.snackbar = true;
          }
          if (error.code === 'auth/invalid-email') {
            this.$store.state.snackText = 'E-Mail hat das falsche Format';
            this.$store.state.snackbar = true;
          }
        });
    },

    login(email, password) {
      this.$store.state.snackText = 'Nutzer erfolgreich angemeldet';
      this.$store.state.snackbar = true;
      this.saveSettings();
      if (localStorage.aff) {
        db.collection('teams')
          .doc(this.$store.state.user_uid)
          .update({ affilliateID: localStorage.aff })
          .then(() => {
            this.$router.push({
              name: 'team_home',
            });
          });
      } else {
        this.$router.push({
          name: 'team_home',
        });
      }
    },

    registerTeam() {
      this.loading = true;

      const data = {
        ...this.settings,
        ...this.common_infos,
        ...this.user_data,
        email: this.email,
        password: this.password,
      };

      if (localStorage.aff) {
        data.affilliateID = localStorage.aff;
      }

      const json = JSON.stringify(data);
      axios({
        method: 'post',
        url: `${cloudFunctions}/createTeamV2`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data: json,
      })
        .then((resp) => {
          this.$store.state.user_uid = resp.data.uid;
          this.loading = false;
        })
        .then(() => {
          this.selectedStep++;
          window.scrollTo(0, 0);
          this.$gtm.push({
            event: 'registration',
            registration_progress: 'success',
            registration_category: 'registerTeam',
          });
        })
        .catch((e) => {
          this.loading = false;

          if (
            e.response &&
            e.response.data &&
            e.response.data.error.code === 'auth/invalid-email'
          ) {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Die Email hat ein falsches Format.',
            });
          } else if (
            e.response &&
            e.response.data &&
            e.response.data.error.code === 'auth/email-already-exists'
          ) {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Die Email existiert schon.',
            });
          } else {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Ups. Da ist wohl etwas schief gelaufen',
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';
.green-line {
  height: 0;
  border: 0;
  border-bottom: 5px solid $primary-dark;
  border-radius: 4px;
  margin: 40px 20%;
}

.middle_header {
  text-align: center;
  margin-bottom: 4px !important;
  font-weight: 600;
}

.register {
  padding: 0;
  margin: 0;
  text-align: center;
}

.v-btn {
  margin-left: 0;
  border-radius: 15px;
  padding: 15px 30px;

  &.green {
    @include mainLinearGradient;
  }
}

.stepper {
  width: 100%;
  min-height: 100vh;
}

.link-no-team,
a {
  color: #24a23d;
}

label {
  font-weight: bold;
  color: $secondary-dark;
  text-align: center;
  font-size: 1.5rem;

  span:last-of-type {
    color: $secondary-light;
  }
}

.items {
  width: 100%;
  background: rgb(248, 248, 248);
  min-height: 93vh;
}

.datepicker {
  margin-bottom: 20px;
}

.items-1 {
  text-align: center;
}

h1 {
  margin-top: 1rem;
}

h2 {
  color: rgb(34, 34, 34);
  font-weight: 400;
  font-size: 20px;
  font-weight: 500;
}
h3 {
  color: $secondary-light;
}

.small-icon {
  align-self: center;
  height: 33px;
}

.icon-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
